import { useNavigate } from 'react-router-dom';
import CardLayout from '../../../components/Layout/CardLayout';
import request from '../../../request/request';
import ProductFormContainer from '../../../components/Forms/Websites/Product/ProductFormContainer';

const AddProduct = () => {
    const navigate = useNavigate();
    const addPackageHandler = (formValues) =>
        request.create('product', formValues, () => {
            navigate('/dashboard/website/product');
        });

    return (
        <CardLayout title='Add New Product'>
            <ProductFormContainer apiHandler={addPackageHandler} />
        </CardLayout>
    );
};

export default AddProduct;
